import React, { useState, useEffect } from 'react';
import { EdgeWhitespaceNotice, fieldsWithEdgeWhitespace } from '../../utils/accountFieldHygiene';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import '../superadmin/AddDistrict.css';

const EditDistrictAdmin = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    title: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAdmin();
  }, [id]);

  const fetchAdmin = async () => {
    try {
      const response = await axios.get('/api/users/my-district-admins');
      const admin = response.data.find(a => a.id === id);
      if (admin) {
        setFormData({
          username: admin.username,
          email: admin.email,
          first_name: admin.first_name,
          last_name: admin.last_name,
          title: admin.title
        });
      }
    } catch (error) {
      console.error('Failed to fetch admin:', error);
      setError('Failed to load admin');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Editing can reintroduce what creation now prevents, so the same rule applies here.
    const dirty = fieldsWithEdgeWhitespace({ Username: formData.username, Email: formData.email });
    if (dirty.length > 0) {
      setError(`Remove the extra space at the start or end of the ${dirty.join(' and ').toLowerCase()} before saving.`);
      return;
    }

    setError('');
    setLoading(true);

    try {
      await axios.put(`/api/users/district-admin/${id}`, formData);
      navigate('/district-admin/admins');
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to update admin');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-district">
      <h2>Edit District Admin</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <EdgeWhitespaceNotice
            fields={{ Username: formData.username, Email: formData.email }}
            onFix={() => { setError(''); setFormData((f) => ({ ...f, username: (f.username || '').trim(), email: (f.email || '').trim() })); }}
          />

          <div className="form-group">
            <label>Username *</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Updating...' : 'Update Admin'}
          </button>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={() => navigate('/district-admin/admins')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditDistrictAdmin;

